<div class="reward-card-root">
  <span class="title" [ngClass]="{ small: isSmall() }">
    {{ reward.modelName || reward.requiredModelName }}
  </span>
  <div ngClass="{{isSmall() ? 'img-reward-container-small' : 'img-reward-container'}}">
    <img *ngIf="reward.imgSource"
         [src]="reward.imgSource"
         [alt]="rewardLabels.rewardImageTitle"
         [title]="rewardLabels.rewardImageTitle"
         [class.small]="isSmall()"
         (error)="handleImageError()"/>
    <div class="default-image" *ngIf="!reward.imgSource">
      <nb-icon icon="printer-outline"></nb-icon>
    </div>
  </div>
  <div class="icons-area" [class.small]="isSmall()">
    <app-sticker-icon [small]="isSmall()" icon="stars">
      {{ cost | number: '':language }}
    </app-sticker-icon>
    <app-icon-click [small]="isSmall()">favorite_outline</app-icon-click>
  </div>
  <div class="details" [class.small]="isSmall()">
    <span class="name">{{ reward.name }}</span>
    <div *ngIf="reward.redemptionLimit > 0"
         class="disclaimer"
         [class.small]="isSmall()">
      *{{ disclaimerLabel }}
    </div>
  </div>
  <div class="button-area" [class.small]="isSmall()">
    <app-primary-button *ngIf="!isSmall()"
                        id="lnr-redeem-reward"
                        class="button"
                        bold
                        [disabled]="isRedeemDisabled()"
                        (clickAction)="openRedeemRewardDialog()">
      <span class="points-left"
            *ngIf="!loading && getMissingPoints() != null && !hasEnoughPoints()">
        <mat-icon> stars </mat-icon>
        <span>{{ getRedeemRewardLabel() }}</span>
      </span>
      <span *ngIf="!loading && (hasEnoughPoints() || getMissingPoints() == null)">
        {{ getRedeemRewardLabel() }}
      </span>
      <span *ngIf="loading" class="loading">
        <mat-spinner></mat-spinner>
      </span>
    </app-primary-button>
    <app-secondary-button *ngIf="isSmall()"
                          id="lnr-reward-details"
                          class="button"
                          light
                          small
                          (clickAction)="openDetails()">
      {{ rewardLabels.rewardDetails }}
    </app-secondary-button>
  </div>
</div>
